import useToast from "hooks/useToast";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { navigateAfterRedsys } from "services/api/redsys.service";
import { setOffSite } from "services/user/user.session.service";

export function ResponseKO(){

    const [t] = useTranslation('paymentMethodsFlow');
    const { openToast } = useToast()

    useEffect(()=>{
        openToast("error", t("literals.errorRequest"), t("literals.errorSaving") );
        const { processId, errorSource } = unMountParams();
        // console.log( processId, errorSource);
        setOffSite(false)
        navigateAfterRedsys();
    },[])

    const unMountParams = ()=>{
        const input = window.location.search;
        if( input ){
            const paramsUnMounted =  input.split("?")[1];
            const paramsStrings = paramsUnMounted.split("&");
            const processId = paramsStrings[0].split("processId=")[1]
            const errorSource = paramsStrings[1].split("errorSource=")[1]
            return {processId, errorSource };
        }else {
            return {processId:"null", errorSource:"null"}
        }
    }

    return(
        <>
        </>
    )
}